import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/projects')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/project' })
  },
})
